import isFunction from "lodash/isFunction";

export type Milliseconds = number;

export const scrollToTop = (delay?: Milliseconds) => {
  if (window && isFunction(window.scrollTo)) {
    if (delay) {
      setTimeout(() => window.scrollTo?.(0, 0), delay);
    } else {
      window.scrollTo?.(0, 0);
    }
  }
};

const scrollToElement = (element: HTMLElement) => {
  element.scrollIntoView({
    behavior: "smooth",
    block: "end",
    inline: "nearest",
  });
};

export const scrollToElementAfterTimeout = (
  element: HTMLElement | null | undefined,
  delay: number
) => {
  setTimeout(() => {
    if (element) {
      scrollToElement(element);
    }
  }, delay);
};
